<template>
  <div class="has-text-left">
    <p class="passwordValidationRules" :class="passwordLength">
      Has at least 8 characters.
    </p>
    <p class="passwordValidationRules" :class="passwordHasLowercase">
      Has at least one lowercase letter.
    </p>
    <p class="passwordValidationRules" :class="passwordHasUppercase">
      Has at least one capital letter.
    </p>
    <p class="passwordValidationRules" :class="passwordHasNumber">
      Has at least one number.
    </p>
    <p class="passwordValidationRules" :class="passwordHasSpecialChar">
      Has at least one special character.
    </p>
  </div>
</template>

<script>
export default {
  name: "PasswordComplexityCheck",

  props: {
    password: {
      type: String,
      default: ""
    }
  },

  computed: {
    passwordLength() {
      return this.password.length >= 8 ? "has-text-success" : "has-text-danger";
    },

    passwordHasNumber() {
      return /\d/.test(this.password) ? "has-text-success" : "has-text-danger";
    },

    passwordHasLowercase() {
      return /[a-z]/.test(this.password)
        ? "has-text-success"
        : "has-text-danger";
    },

    passwordHasUppercase() {
      return /[A-Z]/.test(this.password)
        ? "has-text-success"
        : "has-text-danger";
    },

    passwordHasSpecialChar() {
      return /[^A-Za-z0-9]/.test(this.password)
        ? "has-text-success"
        : "has-text-danger";
    }
  }
};
</script>

<style lang="sass" scoped>
.passwordValidationRules
  font-size: 0.9rem
</style>
